import { Component, computed, inject, signal } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { NavigationComponent } from "../../components/common/navigation/navigation";
import { FooterComponent } from "../../components/common/footer/footer";
import { MatDialog } from "@angular/material/dialog";
import { DialogDomainReportProblemComponent } from "../../components/dialogs/dialog-domain-report-problem/dialog-domain-report-problem";
import { DialogSendDiagnosticsComponent } from "../../components/dialogs/dialog-send-diagnostics/dialog-send-diagnostics";
import { AngularSvgIconModule } from "angular-svg-icon";
import { AuthService } from "../../services/AuthService";

@Component({
  selector: "page-support",
  templateUrl: "support.html",
  styleUrls: ["./support.scss"],
  imports: [FooterComponent, NavigationComponent, TranslateModule, AngularSvgIconModule],
})
export class SupportPage {
  private readonly dialog = inject(MatDialog);
  private readonly auth = inject(AuthService);
  protected lastErrorMessage = signal("");
  protected isErrorPresent = computed(() => this.lastErrorMessage() !== "");

  constructor() {
    this.auth.lastHttpError.subscribe((err) => {
      if (err.error?.detail) {
        this.lastErrorMessage.set(err.error.detail);
      } else {
        this.lastErrorMessage.set(err.message ?? "");
      }
    });
  }

  reportDomainsProblem() {
    this.dialog.open(DialogDomainReportProblemComponent, {});
  }

  reportProblem() {
    this.dialog.open(DialogSendDiagnosticsComponent, {});
  }
}
